export const PHONE_ROUTES = {
  dashboard: '/dashboard/v1',
  'first-time-callers': '/first-time-callers/firsttimelog',
  'phone-log': '/phonelog/all-log',
  fax: '/fax',
};

export const PHONE_PROVIDER_URL = 'https://nextgen.orthovoip.com';
